<template>
  <el-form :model="model" ref="form" :rules="rules">
    <el-form-item>
      <el-alert
        :title="loginError"
        type="error"
        v-if="loginError"
        :closable="false"
      />
      <el-alert
        :title="sendCodeMessage"
        type="error"
        v-if="sendCodeError"
        :closable="false"
      />
    </el-form-item>
    <el-form-item :label-width="0" prop="mobile" ref="mobile">
      <el-input
        v-model="model.mobile"
        size="large"
        :placeholder="$t('login.REGISTER.mobile')"
        prefix-icon="User"
      />
    </el-form-item>
    <el-form-item :label-width="0" prop="code">
      <el-row :gutter="10">
        <el-col :span="14">
          <el-input
            v-model="model.code"
            size="large"
            :placeholder="$t('login.REGISTER.inputsmscode')"
            prefix-icon="Lock"
          />
        </el-col>
        <el-col :span="10">
          <el-button
            size="large"
            :disabled="totalCountdownTime < 60"
            @click="sendSMSCode"
            >{{ btnSMScontent }}</el-button
          >
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        size="large"
        style="width: 100%"
        @click="login"
        >{{ $t('login.LOGIN.login') }}</el-button
      >
    </el-form-item>
  </el-form>
</template>
<script>
import { mapState } from 'vuex';
import SmsMixin from './SmsMixin';
export default {
  mixins: [SmsMixin],
  data() {
    return {
      rules: {
        mobile: [{ validator: this.validateMobile, trigger: 'blur' }],
        code: [
          {
            required: true,
            message: this.$t('login.REGISTER.inputcode'),
            trigger: 'blur',
          },
        ],
      },
      model: {
        mobile: null,
        code: null,
      },
      smsCode: null,
      loading: false,
      error: false,
      sendSmsUrl: '/v1.0/user/mobile/login/code',
    };
  },
  computed: {
    ...mapState('auth', {
      loginError: (state) => state.loginError,
    }),
  },
  methods: {
    async login() {
      let isValid = false;
      await this.$refs.form.validate(
        (valid) => (isValid = valid),
      );
      if (isValid) {
        this.loading = true;
        await this.$store.dispatch('auth/loginByMobile', this.model);
        this.loading = false;
      }
    },
  },
};
</script>
